exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){body.shepherd-active .intro-steps .shepherd-target.shepherd-enabled{position:relative;box-shadow:0 0 0 99999px rgba(0,0,0,.5);z-index:9999;pointer-events:auto;transition:all .3s ease}body.shepherd-active .intro-steps .sub-nav .applicant-button{margin-left:180px;position:fixed}body.shepherd-active .intro-steps .sub-nav .form-button{position:fixed}}@media (max-width:768px){body.shepherd-active .intro-steps .shepherd-target.shepherd-enabled{position:relative;box-shadow:0 0 0 99999px rgba(0,0,0,.5);z-index:9999;pointer-events:auto;transition:all .3s ease}body.shepherd-active .intro-steps .sub-nav .applicant-button.shepherd-target.shepherd-enabled,body.shepherd-active .intro-steps .sub-nav .form-button{position:fixed}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/forms/tour/intro/intro.css
// module id = 755
// module chunks = 0